$(document).ready(function() {
  $('form').on('change', '.membership_type_radio', function(event) {
  });
  // OnLoad trigger
  $('.membership_type_radio:checked').trigger('change');
});
